import { render } from "./TranslatePriceTierListPage.vue?vue&type=template&id=4b4dc5e2&ts=true"
import script from "./TranslatePriceTierListPage.vue?vue&type=script&lang=ts"
export * from "./TranslatePriceTierListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__